<div class="box_item" *ngIf="status==STATUS_DONE else loadingactionsmain">
    <label class="box-label">DESIRED RESULT</label>
    <p class="box_item_minor">What actions should happen when the conditions of the rule are met?</p>
    <!-- <p> ACTIONS WE HAVE???? {{actionForms.length}} </p> -->
    <settings-rules-rule-form-actions-item
        *ngFor="let actionForm of actionForms"
        [actionForm]="actionForm"
        [availableActions]="currentEventActions"
        [ruleActions]="rule.actions"
        (clickAdd)="addAction()"
        (clickRemove)="removeAction($event)"
        (selectAction)="selectAction(actionForm,$event)"
        (variablesChange)="selectParameters(actionForm, $event)"
    ></settings-rules-rule-form-actions-item>
    <div class="action-any" *ngIf="actionForms && actionForms.length == 0">
      <span>Any action selected</span>
      <core-helpers-forms-button-icon [text]="'Add action'" [icon]="'add'" (click)="addAction()" ></core-helpers-forms-button-icon>
  </div>
</div>
<ng-template #loadingactionsmain>
   <div class="loader">
      <div class="dimmed">
        <div class="dimmed_info"></div>
        <div class="dimmed_flex">
          <div class="dimmed_title"></div>
          <div class="dimmed_subtitle"></div>
        </div>
      </div>
    </div>
  </ng-template>
